export default [{
        name: "HTML5 • CSS • JavaScript",
        description: "Fundamental Web Development",
        icon: ['fab', "html5"],
        color: "#EC5F38"
    },
    {
        name: "Vue.js",
        description: "Frontend Web Development",
        icon: ['fab', "vuejs"],
        color: "#41B883"
    },
    {
        name: "NodeJS • MongoDB • ExpressJS",
        description: "Backend Web Development",
        icon: ['fab', "node-js"],
        color: "#659E5A"
    },
    {
        name: "TypeScript",
        description: "Software Development",
        icon: ['fas', "code"],
        color: "#007ACC"
    },
    {
        name: "Linux",
        description: "Cloud Computing/Server Administration",
        icon: ['fab', "linux"],
        color: "#fff"
    },
    {
        name: "Git • GitHub",
        description: "Version Control",
        icon: ['fab', "git-alt"],
        color: "#F75036"
    },
    {
        name: "CI/CD",
        description: "Continous Integration with GitHub Actions.",
        icon: ['fas', "code-branch"],
        color: "#3EB1CA"
    },
    {
        name: "Adobe XD • Photoshop • Lightroom",
        description: "UI Design & Photo Manipulation",
        color: "#E17FDC"
    },
]